import { TYPE_BUTTONS } from '../../../../constans';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';

import { useDispatch } from 'react-redux';
import UserApi from '../../../../API/user/user-api';
import { addStaff } from '../../../../actions/staff';
import PopUp from '../../../Basic/Blocks/PopUp';
import styles from './styles.module.scss';

const DeleteUserPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();

  const clickDelete = async () => {
    await UserApi.removeUser({ data: { login: user.login } })
      .then(() => {
        UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
        close();
      });
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>
        Удалить пользователя {user.name}({user.login})?
      </H2>

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => clickDelete()}>
          Удалить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DeleteUserPopUp;
